export default {
	header: {
		background: '#fff',
		padding: 0,
		position: 'fixed',
		zIndex: '999',
		width: '100%',
		borderBottom: '1px solid #fafafa'
	},
	right: {
		display: 'inline-block',
		float: 'right',
		marginRight: '200px'
	}
};
